/**
 * SEO 配置 - chat (Polski)
 */

export default {
    chat: {
        title: 'Czat AI - Wielomodelowy asystent | WeryAI',
        description:
            'Rozmawiaj z najlepszymi modelami AI na WeryAI. Porównuj odpowiedzi obok siebie w wielu oknach. Generuj obrazy, filmy i muzykę w jednym obszarze roboczym.',
        keywords:
            'czat AI, asystent AI, czat wielomodelowy, chatbot AI, porównywanie modeli AI, czat AI obok siebie, alternatywa GPT, obszar roboczy AI, WeryAI',
        og_title: 'Czat AI - Wielomodelowy asystent | WeryAI',
        og_description:
            'Rozmawiaj z najlepszymi modelami AI i porównuj odpowiedzi obok siebie. Generuj obrazy, filmy i więcej. Wypróbuj za darmo na WeryAI.',
        twitter_title: 'Czat AI - Wielomodelowy asystent | WeryAI',
        twitter_description:
            'Rozmawiaj z najlepszymi modelami AI i porównuj odpowiedzi obok siebie. Generuj obrazy, filmy i więcej. Wypróbuj za darmo na WeryAI.',
    },
}
